export default __webpack_public_path__ + "static/logoWhite-69b49cc0cc3d9d50e5b71e0dabdaeb04.png";